module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_9.65b4038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_9.png
// module id = 0kWM
// module chunks = 0